import { Navigate, useRoutes } from "react-router-dom";
import SimpleLayout from "./layouts/simple";
import PosPage from "./pages/PosPage";
import Menu from "./pages/Selling/Menu";
import Tables from "./pages/Tables";
import Widgets from "./pages/Widgets";
import { useContext } from "react";
import { AppContext } from "./AppContext";
import OrderTabs from "./pages/Tables/OrderTabs";

// ----------------------------------------------------------------------

export default function Router() {
    const { isTabsPos } = useContext(AppContext);
    const routes = useRoutes([
        {
            path: "/tables",
            element: isTabsPos ? <OrderTabs /> : <Tables />,
        },
        {
            path: "/pos/:tableName/:orderName?",
            element: <PosPage />,
        },
        {
            path: "/dashboard",
            children: [
                { element: <Navigate to="/dashboard/selling" />, index: true },
                { path: "menu", element: <Menu /> },
                { path: "widgets", element: <Widgets /> },
            ],
        },
        {
            element: <SimpleLayout />,
            children: [
                { element: <Navigate to="/tables" />, index: true },
                { path: "404", element: <Tables /> },
            ],
        },
    ]);

    return routes;
}
